<template>
  <div class="hm-home">
    <div class="card">
      <div class="panel flex item-center flex-between">
        <div>
          <el-button size="small" type="primary" @click="taskOperation('add')"
            >新建考核任务</el-button
          >
        </div>
        <div class="form-wrapper flex flex-1 flex-wrap flex-end mb20">
          <el-input
            class="mr10"
            size="small"
            clearable
            placeholder="请输入考核任务名"
            v-model.trim="searchConditons.taskName"
            style="width: 150px"
          ></el-input>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <el-table stripe border :data="list" style="width: 100%">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            width="50"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="taskName"
            label="考核任务名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="levelName"
            label="已关联绩效等级"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="levelName"
            label="已关联考核组"
          >
            <template slot-scope="scope">
              <span v-for="(v, i) in scope.row.groupList" :key="i">
                {{ v.groupName }}
                <template v-if="i !== scope.row.groupList.length - 1"
                  >，</template
                >
              </span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="task"
            label="周期类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.loopType === 'year'">年</span>
              <span v-if="scope.row.loopType === 'month'">月</span>
              <span v-if="scope.row.loopType === 'date'">日</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="level"
            label="日期"
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.loopStartValue }}至{{
                  scope.row.loopEndValue
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center item-center">
                <el-button
                  :class="
                    scope.row.enabledState === 'no' ? 'success' : 'danger'
                  "
                  size="small"
                  type="text"
                  @click="stateOperation(scope.row)"
                >
                  {{ scope.row.enabledState === "no" ? "开启" : "关闭" }}
                </el-button>
                <div class="line"></div>
                <el-button
                  class="blue"
                  size="small"
                  type="text"
                  @click="taskOperation('edit', scope.row)"
                  >编辑</el-button
                >
                <div class="line"></div>
                <el-button
                  @click="relationLevel(scope.row)"
                  class="blue"
                  size="small"
                  type="text"
                  >关联绩效等级</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          ref="pagination"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="关联绩效等级"
      width="800px"
      :close-on-click-modal="false"
      :visible.sync="relationDialogVisible"
    >
      <div class="relation-container">
        <div class="label-row">
          <span class="label">考核任务名称</span>
          <span>{{ currentRow.taskName }}</span>
        </div>
        <div class="label-row">
          <span class="label">关联绩效等级</span>
        </div>
        <div class="table">
          <div class="panel">
            <div class="form-wrapper flex flex-end mb20">
              <el-input
                class="mr10"
                size="small"
                clearable
                placeholder="请输入绩效等级名称"
                v-model.trim="levelName"
                style="width: 150px"
              ></el-input>
              <el-button
                class="ml0"
                size="small"
                type="primary"
                @click="queryLevel"
                >查询</el-button
              >
            </div>
          </div>
          <div class="mb20">
            <div class="tips mb10">提示：点击表格行即可选择</div>
            <el-table
              @current-change="handleCurrentChange"
              stripe
              border
              :data="levelList"
              id="table"
              size="small"
            >
              <el-table-column align="center" width="55">
                <template slot-scope="scope">
                  <el-radio :label="scope.row.id" v-model="currentLevel"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                :index="
                  index => index + (levelCurrentPage - 1) * levelPageSize + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="levelName"
                label="绩效等级名称"
              ></el-table-column>
            </el-table>
          </div>
          <div class="hm-pagination mb20">
            <el-pagination
              background
              :total="levelTotal"
              @current-change="levelPaging"
              @size-change="levelHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="levelCurrentPage"
            ></el-pagination>
          </div>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="saveRelation"
            >保存</el-button
          >
          <el-button size="small" @click="relationDialogVisible = false"
            >关闭</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    const validateTimeType = (rule, val, callback) => {
      switch (this.ruleForm.timeType) {
        case "year":
          if (!this.ruleForm.planStartDate || !this.ruleForm.planEndDate) {
            return callback(new Error("请选择起始与结束时间"));
          }
          break;
        case "date":
        case "month":
          if (
            !this.ruleForm.timeDate ||
            (this.ruleForm.timeDate && !this.ruleForm.timeDate.length)
          ) {
            return callback(new Error("请选择起始与结束时间"));
          }
          break;
        default:
          break;
      }
      callback();
    };
    return {
      pageSizeAdd: 10,
      currentPageAdd: 1,
      addList: [],
      dialogVisible: false,
      totalAdd: 0,
      title: "",
      brandAndGoodsDialogVisible: false,
      ruleForm: {
        taskName: "",
        planStartDate: "",
        planEndDate: "",
        timeDate: "",
        timeType: "year",
        calcType: "sum",
        saleAmount: "yes",
        targetComplete: "no",
        fullScore: "",
        targetTask: "",
        targetCompleteField: "",
        saleAmountField: ""
      },
      searchCondition: {},
      type: "",
      category: "",
      selectedCategoryData: [],
      categoryResult: [],
      fields: [],
      categoryList: [
        {
          key: "category",
          value: "品类"
        },
        {
          key: "brand",
          value: "品牌"
        },
        {
          key: "attribute",
          value: "属性"
        },
        {
          key: "goods",
          value: "商品"
        }
      ],
      rules: {
        taskName: {
          required: true,
          message: "请输入考核任务名称",
          trigger: "blur"
        },
        timeType: {
          required: true,
          validator: validateTimeType
        }
      },
      placeholder: "",
      dialogTitle: "添加考核任务",
      levelName: "",
      levelList: [],
      levelTotal: 0,
      currentLevel: "",
      levelCurrentPage: 1,
      groupList: [],
      levelPageSize: 10,
      relationDialogVisible: false,
      searchConditons: {
        taskName: ""
      },
      activeTab: "examineTasK",
      total: 0,
      currentPage: 1,
      list: [],
      currentRow: {},
      pageSize: 10,
      statusList: [
        {
          name: "考核任务设置",
          value: "examineTasK"
        },
        {
          name: "考核组设置",
          value: "examineGroup"
        },
        {
          name: "指标字段设置",
          value: "indicatorField"
        },
        {
          name: "绩效等级设置",
          value: "performanceLevel"
        }
      ],
      pickerOptions: {
        //disabled为函数，返回值为布尔值，
        disabledDate: time => {
          let minYear = new Date(this.ruleForm.planStartDate).getFullYear();
          return time.getTime() < new Date(JSON.stringify(minYear));
        }
      },
      pickerStartOptions: {
        disabledDate: time => {
          let minYear = new Date().getFullYear();
          return time.getTime() < new Date(JSON.stringify(minYear));
        }
      }
    };
  },
  computed: mapGetters(["taskInfo"]),
  watch: {},
  created() {},
  mounted() {
    if (this.taskInfo) {
      this.dialogVisible = true;
      this.ruleForm = this.taskInfo;
      this.$store.commit("SAVE_TASK_INFO", null);
    } else {
      this.queryList();
    }
  },
  methods: {
    handleCurrentChange(row) {
      this.currentLevel = row.id;
    },
    // 打开添加考核组
    addGroup() {
      this.$store.commit("SAVE_TASK_INFO", this.ruleForm);
      this.$emit("switchTab", "examineGroup");
    },
    saveTask() {},
    taskOperation(type, row) {
      let query = {};
      this.operationType = type;
      switch (type) {
        case "add":
          query = {
            operationType: "add"
          };
          break;
        case "edit":
          query = {
            operationType: "edit",
            operationId: row.id
          };
          break;
        default:
          break;
      }
      this.$router.push({
        name: "PerformanceSetting",
        query
      });
    },
    resetRuleForm() {},
    async queryList() {
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      Object.assign(params, this.searchConditons);
      const { result } = await this.$store.dispatch(
        "queryTargetTaskList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    async stateOperation(row) {
      const status = row.enabledState === "no" ? "开启" : "关闭";
      const result = await this.$confirm(`是否${status}任务?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("changeExamineTaskStatus", {
          id: row.id
        });
        this.queryList();
      }
    },
    async relationLevel(row) {
      this.currentRow = row;
      this.relationDialogVisible = true;
      this.queryLevel();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    levelPaging(page) {
      this.levelCurrentPage = page;
      this.queryLevel();
    },
    levelHandleSizeChange(size) {
      this.levelCurrentPage = 1;
      this.pageSize = size;
      this.queryLevel();
    },
    async queryLevel() {
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        levelName: this.levelName
      };
      Object.assign(params, this.searchConditons);
      const { result } = await this.$store.dispatch(
        "queryExamineLevelList",
        params
      );
      const { records, total } = result;
      records.forEach(v => {
        v.checked = false;
      });
      this.levelList = records;

      this.levelTotal = total;
      this.currentLevel = this.currentRow.levelId;
    },
    async saveRelation() {
      if (!this.currentLevel) {
        this.$message({
          type: "warning",
          message: "请先选择等级"
        });
        return;
      }
      await this.$store.dispatch("taskRelationLevel", {
        id: this.currentLevel,
        taskIdList: [
          {
            id: this.currentRow.id
          }
        ],
        bindType: "task"
      });
      this.$message({
        type: "success",
        message: "操作成功"
      });
      this.relationDialogVisible = false;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  background: #fff;
  padding: 15px;
}
.table-panel {
  background: #fff;
  padding: 15px;
}

.table {
  .line {
    width: 1px;
    margin: 0 10px;
    height: 12px;
    background: #ddd;
  }
}

.relation-container {
  .label-row {
    margin-bottom: 20px;
    .label {
      font-size: 14px;
      font-weight: bold;
      margin-right: 20px;
    }
  }
  .panel {
    margin-bottom: 20px;
  }
}

.caption {
  font-size: 16px;
  margin: 28px 0;
  width: 86px;
  text-align: right;
  color: #222;
  &::before {
    content: "";
    width: 4px;
    height: 16px;
    border-radius: 2px 0px 2px 0px;
    background: #e50065;
    margin-right: 5px;
  }
}
</style>
